import React from 'react';
import HTMLParserWrapperComponent from '../widgets/HTMLParserWrapperComponent';
import { formatDate } from '../utils';

function EducationDataComponent(props) {
    const {educationData} = props;

    return (
        
        <div className="accordion" id="educationAccordion">                     
                {
                    (educationData || []).map((item, idx) => {
                        return (
                            <p className="title" key={idx}>
                                <small><strong>{item.eduUniversity} | {item.eduLocation} | {item.eduTitle} | {formatDate(item.eduFromDate)} - {formatDate(item.eduToDate)}</strong></small> <br />
                                <small><HTMLParserWrapperComponent content={item.eduSummary} /></small>
                            </p>
                        )
                    })
                }
            </div>
    );
}

export default EducationDataComponent;